import { GeneralService } from './general.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class CalcStorageDaysService {

    constructor(protected generalService: GeneralService) {
    }

    public calcStorageDaysService(pInicioRetiradaArmazemData: string, pInicioRetiradaArmazemHora: string, pInicioDescargaSiloData: string, pInicioDescargaSiloHora: string, pInicioDebulhaData: string, pInicioDebulhaHora: string, pInicioRetornoSiloData: string, pInicioRetornoSiloHora: string): number {

        const todayDate: Date = new Date();
        const isOkRetArm: boolean = this.isValidDate(pInicioRetiradaArmazemData, pInicioRetiradaArmazemHora);
        const isOkDescSilo: boolean = this.isValidDate(pInicioDescargaSiloData, pInicioDescargaSiloHora);
        const isOkDebulha: boolean = this.isValidDate(pInicioDebulhaData, pInicioDebulhaHora);
        const isOkRetSilo: boolean = this.isValidDate(pInicioRetornoSiloData, pInicioRetornoSiloHora);

        const dtRetArm: Date = this.createDateTime(isOkRetArm, pInicioRetiradaArmazemData, pInicioRetiradaArmazemHora);
        const dtDescSilo: Date = this.createDateTime(isOkDescSilo, pInicioDescargaSiloData, pInicioDescargaSiloHora);
        const dtDebulha: Date = this.createDateTime(isOkDebulha, pInicioDebulhaData, pInicioDebulhaHora);
        const dtRetSilo: Date = this.createDateTime(isOkRetSilo, pInicioRetornoSiloData, pInicioRetornoSiloHora);
        let resultado: number;
        let tempo1: number;
        let tempo2: number;


        if (isOkRetArm === true && isOkDebulha === true && isOkRetSilo === true) {

            tempo1 = this.generalService.CalcTimeDiffDay(dtRetArm, dtDebulha);
            tempo2 = isOkDescSilo ? this.generalService.CalcTimeDiffDay(dtDescSilo, dtRetSilo) : this.generalService.CalcTimeDiffDay(todayDate, dtRetSilo);
            resultado = tempo1 + tempo2;
        }
        else if (isOkRetArm === true && isOkDebulha === true) {

            resultado = this.generalService.CalcTimeDiffDay(dtRetArm, dtDebulha);
        }


        else if (isOkRetArm === false && isOkDescSilo === false) {
            resultado = this.generalService.CalcTimeDiffDay(todayDate, dtDebulha);
        }

        else if (isOkRetArm === true && isOkRetSilo === false && isOkDescSilo === false) {
            resultado = this.generalService.CalcTimeDiffDay(dtRetArm, dtDebulha);
        }

        else if (isOkRetArm === true && isOkRetSilo === true && isOkDescSilo === false) {
            resultado = this.generalService.CalcTimeDiffDayWithFourParams(todayDate, dtDebulha, dtRetSilo, dtRetArm);
        }

        else if (isOkRetArm === false && isOkRetSilo === true && isOkDescSilo === false) {
            resultado = this.generalService.CalcTimeDiffDay(dtRetArm, dtDebulha);
        }

        else if (isOkRetArm === true && isOkRetSilo === true && isOkDescSilo === true) {
            resultado = this.generalService.CalcTimeDiffDayWithFourParams(dtDescSilo, dtDebulha, dtRetSilo, dtRetArm);
        }

        else if (isOkRetArm === false && isOkRetSilo === false && isOkDescSilo === true) {
            resultado = this.generalService.CalcTimeDiffDayWithFourParams(dtDescSilo, dtDebulha, dtRetSilo, dtRetArm);
        }


        return resultado;
    }

    private isValidDate(inicioRetiradaArmazemData: string, inicioRetiradaArmazemHora: string): boolean {
        return this.generalService.isValidDate(inicioRetiradaArmazemData, inicioRetiradaArmazemHora);
    }

    private createDateTime(isOkToCreate: boolean, pDate: string, pHour: string): Date {
        if (isOkToCreate) {
            return this.generalService.createDateTimeData(pDate, pHour);
        }
        return new Date();
    }
}
